import styled from '@emotion/styled';

import { TabletWidth } from '../../../global.style';
import { getColor } from '../UICommon';
import { Col } from '../v2/TwoSidedLayout/TwoSidedLayout.style';

export const PaymentFailureLeftCol = styled(Col)`
  background-color: ${getColor('WHITE')};
  @media (max-width: ${TabletWidth}px) {
    padding: 40px 24px;
    height: 100vh;
  }
`;

export const PaymentFailureContentBoxWrapper = styled.div`
  text-align: left;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: center;
  padding: 100px 10px 100px 90px;

  @media (max-width: ${TabletWidth}px) {
    padding: 0px;
    align-items: center;
    justify-content: flex-start;
  }
`;

export const PaymentFailureContent = styled.div`
  max-width: 580px;

  @media (max-width: ${TabletWidth}px) {
    max-width: 330px;
  }
`;

export const PaymentFailureLogoWrapper = styled.div`
  position: absolute;
  top: 100px;
  left: 90px;

  @media (max-width: ${TabletWidth}px) {
    position: static;
    text-align: left;
    margin-bottom: 32px;
  }
`;

export const PaymentFailureTitle = styled.h3`
  font-family: Lora;
  font-size: 48px;
  font-weight: 500;
  line-height: 56px;
  color: ${getColor('GRAY_95')};

  @media (max-width: ${TabletWidth}px) {
    font-size: 28px;
    font-weight: 600;
    line-height: 32px;
  }
`;

export const PaymentFailureDescription = styled.p`
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  color: ${getColor('GRAY_80')};
  margin-top: 40px;

  @media (max-width: ${TabletWidth}px) {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-top: 8px;
  }
`;

export const PaymentFailureLabel = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: ${getColor('GRAY_80')};
  margin-top: 16px;

  @media (max-width: ${TabletWidth}px) {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin-top: 32px;
  }
`;

export const PaymentFailureButtonWrapper = styled.div`
  margin-top: 48px;
  max-width: 330px;

  @media (max-width: ${TabletWidth}px) {
    margin-top: 32px;
  }
`;
